import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    inner: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(16),
      [theme.fn.largerThan('sm')]: {
        gap: rem(40),
      },
    },
    info: {
      display: 'flex',
      gap: rem(16),
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    infoLeft: {
      display: 'flex',
      gap: rem(16),
      alignItems: 'center',
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(4),
    },
    heading: {},
    thumbnail: {
      width: rem(80),
      flexShrink: 0,
    },
    thumbnailImg: {
      borderRadius: '50%',
      overflow: 'hidden',
      backgroundColor: '#fff',
    },
  }
})
